module.exports = __webpack_public_path__ + "img/28.22dd3172.jpg";